<modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
    <p>
        N'oubliez pas de préciser au client qu'il recevra un SMS du 22305 auquel il devra répondre par OUI afin de
        valider la commande.
    </p>

    <ng-template #customModalFooter>
        <button class="button is-conversion mt-2" (click)="close()">Finaliser la commande</button>
    </ng-template>
</modal>
